
import { useEffect, useState } from 'react';

import { Box, Typography } from '@mui/material';

import CircularProgress, { CircularProgressProps } from '@mui/material/CircularProgress';

function CircularProgressWithLabel( props: CircularProgressProps & { value: number } ) {

    return (
        <Box sx={{ position: 'relative', display: 'inline-flex' }}>

            <CircularProgress variant="determinate" {...props} />

            <Box
                sx={{
                    top: 0,
                    left: 0,
                    bottom: 0,
                    right: 0,
                    position: 'absolute',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}
            >
                <Typography
                    variant="caption"
                    component="div"
                    sx={{ color: 'text.secondary' }}
                >
                    {`${ ( props.value !== 0 ? props.value / 10 : 0 ) }`}
                </Typography>
            </Box>
        </Box>
    );
}

interface Props {
    callback: () => void;
}

export default function CircularWithValueLabel( { callback }: Props ) {
  
    const [progress, setProgress] = useState(200);
    const [initTimer, setInitTimer] = useState(false);

    useEffect( () => {

        let timer: NodeJS.Timer;

        if( progress > 0 ){
            
            timer = setInterval(() => {
                setProgress( ( prevProgress ) => ( prevProgress - 10 ) );
                setInitTimer( true );
            }, 1000);

        }

        return () => clearInterval( timer )

    }, [ progress ]);
 
    if( progress === 0 && initTimer ){
        callback();        
        setInitTimer( false );
    }    

    return <CircularProgressWithLabel value={ progress } color={ progress > 50 ? 'primary' : 'error' } />;
}